import { apiClient } from './client';

export interface Note {
  note_id: number;
  user_id: number;
  query_id: number;
  mood: string | null;
  note_text: string | null;
  created_at: string;
  question_text?: string;
}

export interface NotesResponse {
  success: boolean;
  notes: Note[];
}

export interface NoteResponse {
  success: boolean;
  note_id?: number;
  message?: string;
}

export const getNotes = async (limit = 20): Promise<NotesResponse> => {
  const response = await apiClient.get<NotesResponse>(`/api/user/notes?limit=${limit}`);
  return response as any as NotesResponse;
};

export const createNote = async (
  query_id: number,
  mood: string | null,
  note_text: string
): Promise<NoteResponse> => {
  const response = await apiClient.post<NoteResponse>('/api/user/notes', {
    query_id,
    mood,
    note_text,
  });
  return response as any as NoteResponse;
};

export const updateNote = async (
  note_id: number,
  mood: string | null,
  note_text: string
): Promise<NoteResponse> => {
  const response = await apiClient.patch<NoteResponse>(`/api/user/notes/${note_id}`, {
    mood,
    note_text,
  });
  return response as any as NoteResponse;
};

export const deleteNote = async (note_id: number): Promise<NoteResponse> => {
  const response = await apiClient.delete<NoteResponse>(`/api/user/notes/${note_id}`);
  return response as any as NoteResponse;
};

export const MOOD_OPTIONS = [
  { value: 'happy',   label: '開心', emoji: '😊' },
  { value: 'excited', label: '期待', emoji: '🎉' },
  { value: 'calm',    label: '平靜', emoji: '😌' },
  { value: 'worried', label: '擔心', emoji: '😟' },
  { value: 'sad',     label: '難過', emoji: '😢' },
];
